export enum SessionStatusEnum {
  ACTIVE = "ACTIVE",
  CREATED = "CREATED",
  COMPLETED = "COMPLETED",
  CLOSE = "CLOSE",
  EXPIRED = "EXPIRED",
}
